/* eslint-disable @typescript-eslint/no-explicit-any */
import BackspaceIcon from '@mui/icons-material/Backspace';
import { IconButton, Tooltip } from '@mui/material';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import { IsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import { useTranslation } from 'react-i18next';
import { baseCell } from 'components/cells';

export function ExamProductColumns(handleDelete: (id: number) => void): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'product_code',
      headerName: t(`global.product`),
      width: 300,
      valueGetter: (params) => params.row.product_code,
      renderCell: baseCell
    },
    {
      field: 'product_description',
      headerName: t(`global.description`),
      flex: 1,
      valueGetter: (params) => params.row.product_description,
      renderCell: baseCell
    },
    {
      field: 'warehouse_code',
      headerName: t(`global.warehouse`),
      flex: 1,
      valueGetter: (params) => params.row.warehouse_code,
      renderCell: baseCell
    },
    {
      field: 'quantity',
      headerName: t(`global.quantity`),
      width: 100,
      type: 'number',
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      width: 150,
      getActions: (params: GridRowParams) => [
        <IsTenantAdministrator key={1}>
          <Tooltip title={t('actions.delete')} key="remove">
            <IconButton onClick={() => handleDelete(params.row.id)}>
              <BackspaceIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </IsTenantAdministrator>
      ]
    } as GridColDef
  ];
  return columns;
}
